<script>

import {Menu} from "floating-vue";
import {axios} from "../mixins";

export default {
  name: 'ValidationIcon',
  components: {Menu},
  mixins: [axios],
  props: {
    resourceType: {
      type: String,
      required: true
    },
    resourceId: {
      type: Number,
      required: true
    },
    isValid: {
      type: Boolean,
      required: true
    },
    hasWarning: {
      type: Boolean,
      required: false,
      default: false
    },
    placement: {
      type: String,
      required: false
    },
    reference: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      loadingValidation: false,
      validationErrors: [],
      valid: this.isValid,
      warning: this.hasWarning,
    };
  },

  methods: {
    getValidationErrors() {
      if(this.validationErrors.length === 0){
        if (!this.valid || this.warning) {
          this.loadingValidation = true
          this.$emit('validate', {reference: this.reference, type: this.resourceType, id: this.resourceId})
        } else {
          this.setMessages([['Data is valid.']])
        }
      }
    },
    setMessages(messages) {
      this.validationErrors = messages
      this.loadingValidation = false
    },
    ignoreWarnings() {
      this.post('ignore', {type: this.resourceType, id: this.resourceId}).then((response) => {
        if (this.resourceType === 'fields') {
          location.reload()
        }
        this.$emit('loadFieldYears');
      })
    }
  },
};

</script>

<template>
  <div class="tooltip my-auto mx-auto" @mouseenter="getValidationErrors()">
    <VMenu autohide="0" no-auto-focus>
      <slot name="is-valid" :valid="valid"></slot>
      <template #popper>
        <template v-if="loadingValidation">
          <div class="text-center">
            <span class="mr-2"><i class="fas fa-spinner fa-spin"></i></span> Loading Errors...
          </div>
        </template>
        <template v-else>
          <ul :class="(valid ? `` : `text-red` + ` text-left`)">
            <li v-for="error in validationErrors" class="mb-1">
              {{ error[0] }}
            </li>
          </ul>
          <button v-if="warning && valid"
                  @click="ignoreWarnings()"
                  class="mx-auto mb-1 w-auto button bg-primary border-blue text-blue text-sm hover:bg-grey-lightest focus:bg-grey-lighter">
            Confirm & Ignore
          </button>
        </template>
      </template>
    </VMenu>
  </div>
</template>